import { get, post, updateHeaders } from './http'
//获取当前时间戳，防止浏览器直接读取接口缓存数据
let time=new Date().valueOf();
//发送验证码
export const sendsms = p => post('/teacher/sms/send?time='+time, p);

//手机号验证码登陆
export const mobilelogin = p => post('/teacher/teacher/mobilelogin?time='+time, p);

//老师获取课程
export const teacherpaper = p => post('/teacher/user.course/paper?time='+time, p);

//老师获取对应课程的所有作业
export const paperList = p => post('/teacher/user/course.paper/list?time='+time, p);

//老师获取对应作业详情
export const paperDetails = p => post('/teacher/user/course.paper/detail?time='+time, p);

//老师提交学生成绩
export const submitPaperReview = p => post('/teacher/user/course.paper/submitPaperReview?time='+time, p);

//课程老师批量或者一键提交学生作业
export const coursepartcorrect = p => post('/teacher/user/course.paper/partcorrect?time='+time, p);

//实践老师批量或者一键提交学生作业
export const practicepartcorrect = p => post('/teacher/user/practice.paper/partcorrect?time='+time, p);

//老师获取所有课程
export const allcourse = p => post('/teacher/user.course/list?time='+time, p);

//老师获取课程详情
export const coursedetail = p => post('/teacher/user.course/detail?time='+time, p);

// 获取老师课程列表
export const courselist = p => post('/teacher/teacher.course/list?time='+time, p);

// 获取老师课程列表
export const getSelect = p => post('/teacher/teacher.course/getSelect?time='+time, p);

// 获取师资培训列表
export const traininglist = p => post('/teacher/teacher.training/list?time='+time, p);

// 获取课件详情
export const teachercoursedetail = p => post('/teacher/teacher.course/detail?time='+time, p);

// 获取师资详情
export const trainingdetail = p => post('/teacher/teacher.training/detail?time='+time, p);

// 获取所有老师课件
export const allList = p => post('/teacher/teacher.course/allList?time='+time, p);

// 课程，师资搜索
export const search = p => post('/teacher/search?time='+time, p);

// 上传我的文件
export const uploadFile = p => post('/teacher/teacher.course/uploadFile?time='+time, p);

//
export const profile = p => post('/teacher/teacher/profile?time='+time, p);

// 修改手机号
export const changemobile = p => post('/teacher/teacher/changemobile?time='+time, p);

// 删除我的文件
export const delFile = p => post('/teacher/teacher.course/delFile?time='+time, p);

export const practicelist = p => post('/teacher/user/practice/list?time='+time, p);


export const practicepaperlist = p => post('/teacher/user/practice.paper/list?time='+time, p);

export const practicepaperdet = p => post('/teacher/user/practice.paper/detail?time='+time, p);

export const prasub = p => post('/teacher/user/practice.paper/submitPaperReview?time='+time, p);

export const phonenumberlogin = p => post('/teacher/teacher/login?time='+time, p);


//登录后刷新token
export const updateHeader = (key,params) => updateHeaders(key,params);



// WEBPACK FOOTER //
// ./src/request/api.js